module.exports = __webpack_public_path__ + "static/img/baoye.0249cb73.png";